import { WebsiteConfigTag } from "@enums/websiteConfig";

export const API_URL = process.env.REACT_APP_API_URL;
export const KEY_STORE_USER = "backoffice_user";

export const API_URL_PARTNER = "partners/";
export const API_URL_FAQ = "faqs/";
export const API_URL_NEWS = "news/";
export const API_URL_WEBINAR = "webinars/";
export const API_URL_ARTIST = "artists/";
export const API_URL_AWARD = "awards/";
export const API_URL_PROJECT = "projects/";
export const API_URL_WEBSITE_CONFIG = "website-config/";
export const API_URL_AWARD_VIDEO = `${API_URL_WEBSITE_CONFIG}${WebsiteConfigTag.AwardsVideo}`;
export const API_URL_AWARD_VIDEO_PUBLIC = `public/${API_URL_AWARD_VIDEO}`;
export const API_URL_MEDIA = "media/";
